import Vue from 'vue'
import { Button, Container, Breadcrumb, Card, BreadcrumbItem, Row, Col, Input, Dropdown, DropdownMenu, DropdownItem, Table, TableColumn, Pagination, Dialog, Form, FormItem, Select, Option, Header, Main, Link, Aside, Menu, Submenu, MenuItemGroup, MenuItem, Footer, Upload } from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import { Message, MessageBox } from 'element-ui'

Vue.use(Button)
Vue.use(Container)
Vue.use(Breadcrumb)
Vue.use(Card)
Vue.use(BreadcrumbItem)
Vue.use(Row)
Vue.use(Col)
Vue.use(Input)
Vue.use(Dropdown)
Vue.use(DropdownMenu)
Vue.use(DropdownItem)
Vue.use(Table)
Vue.use(TableColumn)
Vue.use(Pagination)
Vue.use(Dialog)
Vue.use(Form)
Vue.use(FormItem)
Vue.use(Select)
Vue.use(Option)
Vue.use(Header)
Vue.use(Main)
Vue.use(Link)
Vue.use(Aside)
Vue.use(Menu)
Vue.use(Submenu)
Vue.use(MenuItemGroup)
Vue.use(MenuItem)
Vue.use(Footer)
Vue.use(Upload)

Vue.prototype.$message = Message //Message组件需要进行全局挂载
Vue.prototype.$confirm = MessageBox.confirm